// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page.BC-Page__IntegrationDetails .integration-details-container .integration-details-row {
  display: flex;
  gap: 20px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content {
  width: 612px;
  flex-shrink: 0;
}

.BC-Page.BC-Page__IntegrationDetails .integration-details-container .Polaris-Card {
  height: 100%;
}

.BC-Page.BC-Page__IntegrationDetails .integration-details-container .Polaris-Card .card-inner {
  padding: 16px;
  height: 100%;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .Polaris-Card
  .card-inner.card-inner--column {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .Polaris-Card
  .card-inner
  .BC-Switch-Status {
  height: 16px;
  width: 34px;
  margin-right: 8px;
  display: inline-flex;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .Polaris-Card
  .card-inner
  .BC-Switch-Status__Bar {
  width: 34px;
  height: 16px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .Polaris-Card
  .card-inner
  .BC-Switch-Status__Dot {
  width: 16px;
  height: 16px;
  transform: translateX(0);
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .Polaris-DataTable__Table {
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .Polaris-DataTable__Cell:first-child {
  width: 45%;
  white-space: normal;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .Polaris-DataTable__Cell:last-child {
  width: 55%;
  white-space: normal;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .Polaris-DataTable__TableRow:nth-child(odd) {
  background-color: #fafbfb;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .guide {
  margin-bottom: 8px;
  margin-top: 16px;
  text-align: left;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .guide
  .Polaris-Link {
  display: inline-flex;
  align-items: center;
  text-decoration: underline;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .guide
  .Polaris-Link
  .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
  margin-left: 2px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .Polaris-DataTable__Navigation {
  display: none;
}

.BC-Page.BC-Page__IntegrationDetails
  .BC-Switch-Status
  input:checked
  + .BC-Switch-Status__Bar
  .BC-Switch-Status__Dot {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

.BC-Page.BC-Page__IntegrationDetails .BC-Page__Title--Help {
  padding-left: 53px;
}

.BC-Page.BC-Page__IntegrationDetails .integration-details-container .divider {
  border: 1px solid #e1e3e5;
  margin-bottom: 24px;
}

.BC-Page.BC-Page__IntegrationDetails .integration-details-container .recommendation-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  padding: 12px 16px;
  background: #fafbfb;
  border: 1px solid transparent;
  border-radius: 4px;
}

.BC-Page.BC-Page__IntegrationDetails .integration-details-container .recommendation-item:hover {
  border: 1px solid #1f5199;
  background: #edf4fe;
}

.BC-Page.BC-Page__IntegrationDetails .integration-details-container .recommendation-item__title {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .recommendation-item
  .recommendation-item__title
  .text-ai {
  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .recommendation-item
  .recommendation-item__title
  .Polaris-Badge {
  background: #ff30001a;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .recommendation-item
  .recommendation-item__title
  .Polaris-Badge
  > span {
  display: flex;
  align-items: center;
  gap: 2px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .recommendation-item
  .Polaris-ButtonGroup {
  flex-shrink: 0;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .recommendation-item
  .Polaris-ButtonGroup
  .Polaris-ButtonGroup__Item:first-child
  .Polaris-Button {
  padding: 5px;
  min-width: 30px;
  min-height: 30px;
  width: 30px;
  height: 30px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .recommendation-item
  .Polaris-ButtonGroup
  .Polaris-ButtonGroup__Item:last-child
  .Polaris-Button {
  padding: 5px 12px;
  width: 78px;
  height: 30px;
  min-height: 30px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .text-coming-soon {
  font-weight: 600;
  font-size: 16px;
  margin: 2px 0;
  line-height: 24px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .card-inner--center {
  text-align: center;
  padding-bottom: 20px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .integration-details-event {
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .integration-details-event
  .integration-details-event-collapse__toggle {
  background-color: #fafbfb;
  padding: 12px 16px;
  display: flex;
  gap: 4px;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 1px solid #e1e3e5;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .integration-details-event
  .integration-details-event-wrapper:first-child
  .integration-details-event-collapse__toggle {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .integration-details-event
  .integration-details-event-wrapper:last-child
  .integration-details-event-collapse__toggle {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 0;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .integration-details-event
  .integration-details-event-collapse__content {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e1e3e5;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .integration-details-event
  .integration-details-event-collapse__content
  .integration-details-event-collapse__content__title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-basis: 50%;
  padding-left: 24px;
}

.BC-Page.BC-Page__IntegrationDetails
  .integration-details-container
  .integration-details-col-content
  .integration-details-event
  .integration-details-event-collapse__content
  p {
  flex-basis: 50%;
  text-align: left;
}

.BC-Page.BC-Page__IntegrationDetails ~ #PolarisPortalsContainer .Polaris-Modal-Dialog--sizeLarge {
  max-width: 1015px;
}

.BC-Page.BC-Page__IntegrationDetails .card-inner__flex {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page.BC-Page__IntegrationDetails .card-inner__flex .BC-Checkbox-Status {
  margin-right: 0;
}

.BC-Page.BC-Page__IntegrationDetails .card-inner__instruction {
  padding-left: 42px;
  margin-top: 4px;
  color: rgb(109, 113, 117);
  display: flex;
  text-align: left;
}

.BC-Page.BC-Page__IntegrationDetails .card-inner__instruction .Polaris-Link {
  display: inline-flex;
  margin-left: 4px;
  text-decoration: none;
}

.BC-Page.BC-Page__IntegrationDetails .card-inner__instruction .Polaris-Button {
  margin-right: 5px;
}

.BC-Page.BC-Page__IntegrationDetails .banner-error .Polaris-Button {
  background-color: initial;
  border-color: rgba(224, 179, 178, 1);
  margin-top: 5px;
}

.BC-Page.BC-Page__IntegrationDetails .card-inner__instruction .Polaris-Icon {
  width: 18px;
  height: 18px;
  margin-left: 2px;
}

.BC-Page.BC-Page__IntegrationDetails .card-inner__instruction .Polaris-Icon .Polaris-Icon__Svg, .noMetafield .Polaris-Icon .Polaris-Icon__Svg {
  fill: rgb(44, 110, 203);
}

.integration-details-preview-modal {
  display: flex;
}

.integration-details-preview-modal .integration-details-preview-modal__guideline {
  width: 620px;
  padding: 20px;
  border-right: 1px solid #e1e3e5;
}

.integration-details-preview-modal .integration-details-preview-modal__guideline .title-section {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.integration-details-preview-modal .integration-details-preview-modal__guideline .Polaris-Link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.integration-details-preview-modal .integration-details-preview-modal__guideline .feed-name {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  gap: 4px;
}

.integration-details-preview-modal
  .integration-details-preview-modal__guideline
  .feed-name
  .Polaris-Badge--statusInfo {
  background-color: #e0f0ff;
  color: #00527c;
  font-weight: 500;
}

.integration-details-preview-modal .integration-details-preview-modal__guideline .Polaris-Icon {
  margin: 0;
}

.integration-details-preview-modal
  .integration-details-preview-modal__guideline
  .guide-content
  .Polaris-Icon
  .Polaris-Icon__Svg {
  fill: #2c6fcd;
}

.integration-details-preview-modal
  .integration-details-preview-modal__guideline
  .code
  .Polaris-Icon
  .Polaris-Icon__Svg {
  fill: #8c9196;
}

.integration-details-preview-modal
  .integration-details-preview-modal__guideline
  .code
  .Polaris-Icon:hover
  .Polaris-Icon__Svg {
  fill: rgb(26, 28, 29);
}

.integration-details-preview-modal
  .integration-details-preview-modal__guideline
  .integration-details-preview-modal__actions
  .Polaris-ButtonGroup {
  gap: 20px;
}

.integration-details-preview-modal
  .integration-details-preview-modal__guideline
  .integration-details-preview-modal__actions
  .Polaris-ButtonGroup__Item {
  margin: 0;
}

.integration-details-preview-modal .integration-details-preview-modal__guideline .code {
  max-height: 414px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
}

.integration-details-preview-modal .integration-details-preview-modal__guideline .code p {
  white-space: pre-wrap;
  max-width: 97%;
  margin-top: -24px;
}

.integration-details-preview-modal
  .integration-details-preview-modal__guideline
  .code
  .Polaris-Button {
  position: sticky;
  top: 0;
  left: 100%;
  transform: translate(-50%, 0);
  padding: 0;
  width: 16px;
  height: 16px;
  min-width: unset;
  min-height: unset;
}

.integration-details-preview-modal .loading-sync {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0;
}

.integration-details-preview-modal .integration-details-preview-modal__preview-content {
  flex: 1;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .title-preview {
  padding: 12px;
  width: 100%;
  border-bottom: 1px solid #e1e3e5;
  text-align: center;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .preview-content {
  padding: 16px 20px;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .preview-content--AI {
  overflow: hidden;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .preview-content
  .title-type {
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
  line-height: 32px;
  text-align: center;
  margin-bottom: 16px;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container {
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 16px;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container
  .product-item {
  width: calc(50% - 10px);
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container
  .product-item
  .product-item__thumbnail {
  margin-bottom: 10px;
  text-align: center;
  aspect-ratio: 1;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container
  .product-item
  .product-item__thumbnail
  img {
  max-width: 100%;
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: center;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container
  .product-item
  .product-item__info__title {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: rgb(32, 34, 35);
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container
  .product-item
  .product-item__info__price-wrapper {
  text-align: center;
  margin-top: 6px;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container
  .product-item
  .product-item__info__price {
  font-weight: 500;
  color: #6d7175;
  text-align: center;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container
  .product-item
  .product-item__info__compare-price {
  color: #9b9b9b;
  text-decoration: line-through;
  margin-left: 6px;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container
  .product-item
  .product-item__thumbnail
  .Polaris-SkeletonThumbnail {
  max-width: 100%;
  height: 100%;
  width: 100%;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container
  .product-item
  .product-item__info
  .Polaris-SkeletonDisplayText__DisplayText {
  width: 100%;
  margin: auto;
  height: 20px;
  max-width: 6.5rem;
}

.integration-details-preview-modal
  .integration-details-preview-modal__preview-content
  .product-container
  .product-item
  .product-item__info
  > .Polaris-SkeletonDisplayText__DisplayText {
  max-width: 8rem;
  height: 24px;
}

.banner-error {
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/integration-details.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;;EAKE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;;;EAIE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;EAIE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;EAIE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;;EAKE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;;;;EAME,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;EAKE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;;;EAKE,sEAAsE;EACtE,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;;;EAME,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;;EAIE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;EAIE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;EAKE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;;;;;EAME,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;;;;;EAME,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;;;;EAKE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;;;EAME,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;EAIE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;EAIE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;;;EAGE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;;;;EAKE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;;EAME,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;;EAKE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;EAKE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;EAKE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;;;;;EAME,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;;;EAME,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".BC-Page.BC-Page__IntegrationDetails .integration-details-container .integration-details-row {\n  display: flex;\n  gap: 20px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content {\n  width: 612px;\n  flex-shrink: 0;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .integration-details-container .Polaris-Card {\n  height: 100%;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .integration-details-container .Polaris-Card .card-inner {\n  padding: 16px;\n  height: 100%;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .Polaris-Card\n  .card-inner.card-inner--column {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .Polaris-Card\n  .card-inner\n  .BC-Switch-Status {\n  height: 16px;\n  width: 34px;\n  margin-right: 8px;\n  display: inline-flex;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .Polaris-Card\n  .card-inner\n  .BC-Switch-Status__Bar {\n  width: 34px;\n  height: 16px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .Polaris-Card\n  .card-inner\n  .BC-Switch-Status__Dot {\n  width: 16px;\n  height: 16px;\n  transform: translateX(0);\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .Polaris-DataTable__Table {\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .Polaris-DataTable__Cell:first-child {\n  width: 45%;\n  white-space: normal;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .Polaris-DataTable__Cell:last-child {\n  width: 55%;\n  white-space: normal;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .Polaris-DataTable__TableRow:nth-child(odd) {\n  background-color: #fafbfb;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .guide {\n  margin-bottom: 8px;\n  margin-top: 16px;\n  text-align: left;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .guide\n  .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: underline;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .guide\n  .Polaris-Link\n  .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  margin-left: 2px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .Polaris-DataTable__Navigation {\n  display: none;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .BC-Switch-Status\n  input:checked\n  + .BC-Switch-Status__Bar\n  .BC-Switch-Status__Dot {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n.BC-Page.BC-Page__IntegrationDetails .BC-Page__Title--Help {\n  padding-left: 53px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .integration-details-container .divider {\n  border: 1px solid #e1e3e5;\n  margin-bottom: 24px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .integration-details-container .recommendation-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 32px;\n  padding: 12px 16px;\n  background: #fafbfb;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .integration-details-container .recommendation-item:hover {\n  border: 1px solid #1f5199;\n  background: #edf4fe;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .integration-details-container .recommendation-item__title {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .recommendation-item\n  .recommendation-item__title\n  .text-ai {\n  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: 600;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .recommendation-item\n  .recommendation-item__title\n  .Polaris-Badge {\n  background: #ff30001a;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .recommendation-item\n  .recommendation-item__title\n  .Polaris-Badge\n  > span {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .recommendation-item\n  .Polaris-ButtonGroup {\n  flex-shrink: 0;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .recommendation-item\n  .Polaris-ButtonGroup\n  .Polaris-ButtonGroup__Item:first-child\n  .Polaris-Button {\n  padding: 5px;\n  min-width: 30px;\n  min-height: 30px;\n  width: 30px;\n  height: 30px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .recommendation-item\n  .Polaris-ButtonGroup\n  .Polaris-ButtonGroup__Item:last-child\n  .Polaris-Button {\n  padding: 5px 12px;\n  width: 78px;\n  height: 30px;\n  min-height: 30px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .text-coming-soon {\n  font-weight: 600;\n  font-size: 16px;\n  margin: 2px 0;\n  line-height: 24px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .card-inner--center {\n  text-align: center;\n  padding-bottom: 20px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .integration-details-event {\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .integration-details-event\n  .integration-details-event-collapse__toggle {\n  background-color: #fafbfb;\n  padding: 12px 16px;\n  display: flex;\n  gap: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .integration-details-event\n  .integration-details-event-wrapper:first-child\n  .integration-details-event-collapse__toggle {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .integration-details-event\n  .integration-details-event-wrapper:last-child\n  .integration-details-event-collapse__toggle {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-bottom: 0;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .integration-details-event\n  .integration-details-event-collapse__content {\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .integration-details-event\n  .integration-details-event-collapse__content\n  .integration-details-event-collapse__content__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-basis: 50%;\n  padding-left: 24px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails\n  .integration-details-container\n  .integration-details-col-content\n  .integration-details-event\n  .integration-details-event-collapse__content\n  p {\n  flex-basis: 50%;\n  text-align: left;\n}\n\n.BC-Page.BC-Page__IntegrationDetails ~ #PolarisPortalsContainer .Polaris-Modal-Dialog--sizeLarge {\n  max-width: 1015px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .card-inner__flex {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .card-inner__flex .BC-Checkbox-Status {\n  margin-right: 0;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .card-inner__instruction {\n  padding-left: 42px;\n  margin-top: 4px;\n  color: rgb(109, 113, 117);\n  display: flex;\n  text-align: left;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .card-inner__instruction .Polaris-Link {\n  display: inline-flex;\n  margin-left: 4px;\n  text-decoration: none;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .card-inner__instruction .Polaris-Button {\n  margin-right: 5px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .banner-error .Polaris-Button {\n  background-color: initial;\n  border-color: rgba(224, 179, 178, 1);\n  margin-top: 5px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .card-inner__instruction .Polaris-Icon {\n  width: 18px;\n  height: 18px;\n  margin-left: 2px;\n}\n\n.BC-Page.BC-Page__IntegrationDetails .card-inner__instruction .Polaris-Icon .Polaris-Icon__Svg, .noMetafield .Polaris-Icon .Polaris-Icon__Svg {\n  fill: rgb(44, 110, 203);\n}\n\n.integration-details-preview-modal {\n  display: flex;\n}\n\n.integration-details-preview-modal .integration-details-preview-modal__guideline {\n  width: 620px;\n  padding: 20px;\n  border-right: 1px solid #e1e3e5;\n}\n\n.integration-details-preview-modal .integration-details-preview-modal__guideline .title-section {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  margin-bottom: 8px;\n}\n\n.integration-details-preview-modal .integration-details-preview-modal__guideline .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n}\n\n.integration-details-preview-modal .integration-details-preview-modal__guideline .feed-name {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n  gap: 4px;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__guideline\n  .feed-name\n  .Polaris-Badge--statusInfo {\n  background-color: #e0f0ff;\n  color: #00527c;\n  font-weight: 500;\n}\n\n.integration-details-preview-modal .integration-details-preview-modal__guideline .Polaris-Icon {\n  margin: 0;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__guideline\n  .guide-content\n  .Polaris-Icon\n  .Polaris-Icon__Svg {\n  fill: #2c6fcd;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__guideline\n  .code\n  .Polaris-Icon\n  .Polaris-Icon__Svg {\n  fill: #8c9196;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__guideline\n  .code\n  .Polaris-Icon:hover\n  .Polaris-Icon__Svg {\n  fill: rgb(26, 28, 29);\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__guideline\n  .integration-details-preview-modal__actions\n  .Polaris-ButtonGroup {\n  gap: 20px;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__guideline\n  .integration-details-preview-modal__actions\n  .Polaris-ButtonGroup__Item {\n  margin: 0;\n}\n\n.integration-details-preview-modal .integration-details-preview-modal__guideline .code {\n  max-height: 414px;\n  overflow: auto;\n  scrollbar-width: thin;\n  scrollbar-gutter: stable;\n}\n\n.integration-details-preview-modal .integration-details-preview-modal__guideline .code p {\n  white-space: pre-wrap;\n  max-width: 97%;\n  margin-top: -24px;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__guideline\n  .code\n  .Polaris-Button {\n  position: sticky;\n  top: 0;\n  left: 100%;\n  transform: translate(-50%, 0);\n  padding: 0;\n  width: 16px;\n  height: 16px;\n  min-width: unset;\n  min-height: unset;\n}\n\n.integration-details-preview-modal .loading-sync {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  padding: 20px 0;\n}\n\n.integration-details-preview-modal .integration-details-preview-modal__preview-content {\n  flex: 1;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .title-preview {\n  padding: 12px;\n  width: 100%;\n  border-bottom: 1px solid #e1e3e5;\n  text-align: center;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .preview-content {\n  padding: 16px 20px;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .preview-content--AI {\n  overflow: hidden;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .preview-content\n  .title-type {\n  font-weight: 600;\n  font-size: 20px;\n  text-transform: uppercase;\n  line-height: 32px;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container {\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 20px;\n  row-gap: 16px;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container\n  .product-item {\n  width: calc(50% - 10px);\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container\n  .product-item\n  .product-item__thumbnail {\n  margin-bottom: 10px;\n  text-align: center;\n  aspect-ratio: 1;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container\n  .product-item\n  .product-item__thumbnail\n  img {\n  max-width: 100%;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  object-position: center;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container\n  .product-item\n  .product-item__info__title {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  color: rgb(32, 34, 35);\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container\n  .product-item\n  .product-item__info__price-wrapper {\n  text-align: center;\n  margin-top: 6px;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container\n  .product-item\n  .product-item__info__price {\n  font-weight: 500;\n  color: #6d7175;\n  text-align: center;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container\n  .product-item\n  .product-item__info__compare-price {\n  color: #9b9b9b;\n  text-decoration: line-through;\n  margin-left: 6px;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container\n  .product-item\n  .product-item__thumbnail\n  .Polaris-SkeletonThumbnail {\n  max-width: 100%;\n  height: 100%;\n  width: 100%;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container\n  .product-item\n  .product-item__info\n  .Polaris-SkeletonDisplayText__DisplayText {\n  width: 100%;\n  margin: auto;\n  height: 20px;\n  max-width: 6.5rem;\n}\n\n.integration-details-preview-modal\n  .integration-details-preview-modal__preview-content\n  .product-container\n  .product-item\n  .product-item__info\n  > .Polaris-SkeletonDisplayText__DisplayText {\n  max-width: 8rem;\n  height: 24px;\n}\n\n.banner-error {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
